module.exports = __webpack_public_path__ + "static/media/kehuxinxi62.64d187aa.png";